import {makeStyles} from "@material-ui/core";

const globalStyle = makeStyles((theme) => ({
    errorLabel: {
        fontSize: "0.75rem",
        marginTop:theme.spacing(1),
        marginBottom:theme.spacing(1),
        color: theme.palette.error.main
    }
}))

export default globalStyle;
